import { render, staticRenderFns } from "./CardResumeClassification.vue?vue&type=template&id=79b4d785&scoped=true"
import script from "./CardResumeClassification.vue?vue&type=script&lang=js"
export * from "./CardResumeClassification.vue?vue&type=script&lang=js"
import style0 from "./CardResumeClassification.vue?vue&type=style&index=0&id=79b4d785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b4d785",
  null
  
)

export default component.exports